import React from "react";
import { Link } from "react-router";
import { useAuth } from "../../../features/auth/AuthContext";
import { downloadFolder, formatPath } from "../utils/utils";
import Loader from "./Loader";
import { handleFavourites } from "../utils/fileActions";
import { Tooltip } from "@mui/material";
import {
  ActiveStarIcon,
  fileIcons,
  SourceIcon,
  StarIcon,
  TimerIcon,
} from "../Icons";
import { format } from "date-fns";

const SecondaryFolder = ({
  label = "Courses",
  isFav = false,
  folder,
  changeFav,
  folderClick,
  folderClickFromView,
  downloadClick,
}) => {
  // console.log(folder, "check folder");
  const { token } = useAuth();

  const isDisabled = folder?.files_count === 0 && folder?.folders_count === 0;

  const FolderIcon = fileIcons?.["folder"];
  const path = formatPath(folder?.full_path);
  const handleFolderClick = () => {
    folderClick
      ? folderClick?.(folder?.path_description)
      : folderClickFromView?.(folder);
  };

  return (
    <div className="group relative bg-[#F7F7F7] flex py-2 px-4 items-center justify-between w-full rounded-md">
      <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block z-50">
        <div className="flex flex-col gap-3 bg-white shadow-lg rounded-[12px] p-3 w-max min-w-[180px] max-w-[90vw] sm:min-w-[220px] sm:max-w-[350px] md:max-w-[400px] border border-gray-200">
          <div className="flex items-center justify-between gap-1">
            <div className="flex items-center gap-1 max-w-[50%]">
              <FolderIcon />
              <span className="text-[0.85rem] text-[#333333] max-w-[80%] truncate font-medium">
                {folder?.folder_name}
              </span>
            </div>
            <div className="file-type">Generated</div>
            {!isFav ? <StarIcon /> : <ActiveStarIcon />}
          </div>

          <div className="flex items-center gap-2">
            <TimerIcon />
            <span className="text-[#232323] font-normal text-[0.9rem]">
              {format(new Date(folder?.updated_at), "dd/MM/yy HH:MM")}
            </span>
          </div>

          <div className="flex gap-2 items-center">
            <SourceIcon />
            <span className="text-[#666666] text-[0.9rem] font-normal break-words whitespace-normal">{path || "-"}</span>
          </div>
        </div>
      </div>
      <div className="flex gap-2 items-center w-full ">
        <button className="fav-btn" onClick={() => changeFav(folder)}>
          {!isFav ? (
            <Tooltip title="Add to Favourite">
              <svg
                width="15"
                height="15"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.78584 10.2965L6.41084 8.71312L9.03584 10.3173L8.34834 7.31729L10.6608 5.31729L7.61917 5.04646L6.41084 2.21312L5.2025 5.02562L2.16084 5.29646L4.47334 7.31729L3.78584 10.2965ZM6.41084 10.1827L3.16896 12.1377C3.04813 12.2083 2.92708 12.2379 2.80584 12.2267C2.68458 12.2154 2.57486 12.1746 2.47667 12.1042C2.37834 12.0336 2.30243 11.9415 2.24896 11.8277C2.19563 11.714 2.18708 11.5881 2.22334 11.4502L3.08396 7.76917L0.221877 5.29167C0.114932 5.19875 0.0468071 5.09111 0.0175016 4.96875C-0.0119429 4.84639 -0.00423455 4.7275 0.0406266 4.61208C0.0854877 4.49681 0.15014 4.40257 0.234585 4.32937C0.319029 4.25618 0.434446 4.20833 0.580835 4.18583L4.35792 3.85583L5.82438 0.379791C5.87771 0.250486 5.95861 0.15486 6.06709 0.0929159C6.17556 0.0309714 6.29014 0 6.41084 0C6.53153 0 6.64611 0.0309714 6.75459 0.0929159C6.86306 0.15486 6.94396 0.250486 6.99729 0.379791L8.46375 3.85583L12.2408 4.18583C12.3872 4.20833 12.5026 4.25618 12.5871 4.32937C12.6715 4.40257 12.7362 4.49681 12.781 4.61208C12.8259 4.7275 12.8336 4.84639 12.8042 4.96875C12.7749 5.09111 12.7067 5.19875 12.5998 5.29167L9.73771 7.76917L10.5983 11.4502C10.6346 11.5881 10.626 11.714 10.5727 11.8277C10.5192 11.9415 10.4433 12.0336 10.345 12.1042C10.2468 12.1746 10.1371 12.2154 10.0158 12.2267C9.89459 12.2379 9.77354 12.2083 9.65271 12.1377L6.41084 10.1827Z"
                  fill="#B3B3B3"
                />
              </svg>
            </Tooltip>
          ) : (
            <Tooltip title="Remove from favourite">
              <svg
                width="15"
                height="15"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.03906 3.95312L1.03906 4.45312L3.03906 6.45312L2.53906 9.45312L5.03906 7.95312L7.53906 9.45312L7.03906 6.45312L9.03906 4.45312H6.03906L5.03906 1.45312L4.03906 3.95312Z"
                  fill="#FFBA00"
                  stroke="#FFBA00"
                  stroke-linecap="round"
                />
              </svg>
            </Tooltip>
          )}
        </button>
        <button
          className="bg-transparent p-0 m-0 w-full border-none"
          onClick={handleFolderClick}
        >
          <div className="flex gap-2 items-center">
            <FolderIcon />
            {/* <svg
              width="16"
              height="12"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.0525 13.6364C1.49144 13.6364 1.00909 13.4345 0.605455 13.0309C0.201818 12.6273 0 12.1449 0 11.5839V2.0525C0 1.48083 0.201818 0.995833 0.605455 0.5975C1.00909 0.199166 1.49144 0 2.0525 0H5.17364C5.45 0 5.71523 0.0507578 5.96932 0.152273C6.22341 0.25394 6.45333 0.408334 6.65909 0.615455L8.81636 2.77273H15.9475C16.5192 2.77273 17.0042 2.97189 17.4025 3.37023C17.8008 3.76856 18 4.25356 18 4.82523V11.5839C18 12.1449 17.8008 12.6273 17.4025 13.0309C17.0042 13.4345 16.5192 13.6364 15.9475 13.6364H2.0525Z"
                fill="#666666"
              />
            </svg> */}

            <span
              title={label}
              className="sec-folder-label truncate max-w-[70%]"
            >
              {label}
            </span>
          </div>
        </button>
      </div>
      <Tooltip title="Download Folder">
        <button
          disabled={isDisabled}
          className="bg-transparent border-0 m-0 p-0"
          onClick={() => downloadFolder(token, folder.id, folder?.folder_name)}
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.25 9.09292C6.14958 9.09292 6.05611 9.07687 5.96958 9.04479C5.88306 9.01285 5.80076 8.95785 5.72271 8.87979L3.13146 6.28854C3.00757 6.16451 2.94639 6.01944 2.94792 5.85333C2.94958 5.68722 3.01076 5.53951 3.13146 5.41021C3.26076 5.28104 3.40924 5.21431 3.57687 5.21C3.74465 5.20569 3.89319 5.26819 4.0225 5.3975L5.625 7V0.625C5.625 0.447639 5.68486 0.299167 5.80458 0.179583C5.92417 0.059861 6.07264 0 6.25 0C6.42736 0 6.57583 0.059861 6.69542 0.179583C6.81514 0.299167 6.875 0.447639 6.875 0.625V7L8.4775 5.3975C8.60153 5.27361 8.74868 5.21243 8.91896 5.21396C9.08937 5.21563 9.23924 5.28104 9.36854 5.41021C9.48924 5.53951 9.55174 5.6859 9.55604 5.84937C9.56035 6.01285 9.49785 6.15924 9.36854 6.28854L6.77729 8.87979C6.69924 8.95785 6.61694 9.01285 6.53042 9.04479C6.44389 9.07687 6.35042 9.09292 6.25 9.09292ZM1.50646 12.5C1.08549 12.5 0.729167 12.3542 0.4375 12.0625C0.145833 11.7708 0 11.4145 0 10.9935V9.35896C0 9.1816 0.059861 9.03312 0.179583 8.91354C0.299167 8.79382 0.447639 8.73396 0.625 8.73396C0.802361 8.73396 0.950833 8.79382 1.07042 8.91354C1.19014 9.03312 1.25 9.1816 1.25 9.35896V10.9935C1.25 11.0577 1.27674 11.1165 1.33021 11.1698C1.38354 11.2233 1.44229 11.25 1.50646 11.25H10.9935C11.0577 11.25 11.1165 11.2233 11.1698 11.1698C11.2233 11.1165 11.25 11.0577 11.25 10.9935V9.35896C11.25 9.1816 11.3099 9.03312 11.4296 8.91354C11.5492 8.79382 11.6976 8.73396 11.875 8.73396C12.0524 8.73396 12.2008 8.79382 12.3204 8.91354C12.4401 9.03312 12.5 9.1816 12.5 9.35896V10.9935C12.5 11.4145 12.3542 11.7708 12.0625 12.0625C11.7708 12.3542 11.4145 12.5 10.9935 12.5H1.50646Z"
              fill={isDisabled ? "#BDBDBD" : "#4D4D4D"}
            />
          </svg>
        </button>
      </Tooltip>
    </div>
  );
};

export default SecondaryFolder;
